import { useEffect } from 'react'

import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'

import { initTheme, Theme } from '@interco/inter-ui'
import { TrackData } from '@inter/track'
import { RootError } from '@/pages'
import Header from '@/components/Header'
import { AboutOpenFinance } from '@/pages/AboutOpenFinance'
import { AboutAccountLink } from '@/pages/AboutAccountLink'
import { Register } from '@/pages/Register'
import { CreditCard } from '@/pages/CreditCard'
import { Account } from '@/pages/Account'
import { Exchange } from '@/pages/Exchange'
import { Investing } from '@/pages/Investing'
import { CreditOperations } from '@/pages/CreditOperations'
import { AboutSendData } from '@/pages/AboutSendData'

import { Container } from './styles'

const WebRouter = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      errorElement: <RootError />,
      element: <Root />,
      children: [
        {
          path: 'about-account-link',
          element: <AboutAccountLink />,
        },
        {
          path: 'about-send-data',
          element: <AboutSendData />,
        },
        {
          path: 'about-open-finance',
          element: <AboutOpenFinance />,
        },
        {
          path: 'register',
          element: <Register />,
        },
        {
          path: 'credit-card',
          element: <CreditCard />,
        },
        {
          path: 'account',
          element: <Account />,
        },
        {
          path: 'exchange',
          element: <Exchange />,
        },
        {
          path: 'investing',
          element: <Investing />,
        },
        {
          path: 'credit-operations',
          element: <CreditOperations />,
        },
      ],
    },
  ])
  return <RouterProvider router={router} />
}

export default WebRouter

export const Root = () => {
  useEffect(() => {
    initTheme(Theme.PF)
  }, [])
  TrackData.initOrUpdate({
    runtimeEnv: (process.env.REACT_APP_NODE_ENV as EnvType) || '',
    projectName: 'webview-openfinance-faq',
  })
  return (
    <Container>
      <Header />
      <Outlet />
    </Container>
  )
}
